import * as React from 'react'
import useSWR from 'swr'
import axios from 'axios'
import { useLocale } from 'hooks'
import type { AuthCentre } from 'types/authCentre'

const cachedData = window.localStorage.getItem('laced-auth-centres')
const fallbackData = cachedData ? JSON.parse(cachedData) : []

export const useAuthCentres = () => {
  const { localiseUrl } = useLocale()
  const { data, isValidating } = useSWR(
    '/api/auth_centres',
    (url) =>
      axios
        .get(localiseUrl(url, { localeAsParam: true }))
        .then((res) => res.data),
    { fallbackData }
  )

  React.useEffect(() => {
    if (data) {
      window.localStorage.setItem('laced-auth-centres', JSON.stringify(data))
    }
  }, [data])
  return {
    authCentres: data as AuthCentre[],
    fetchingAuthCentres: isValidating
  }
}
